var _circle, _line, _circle2, _path, _circle3, _circle4, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 26,
    stroke: "#d4a017",
    strokeWidth: 3,
    fill: "none",
    strokeDasharray: "4 3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: 42,
    x2: 42,
    y2: 18,
    stroke: "#b23a00",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 18,
    r: 2,
    fill: "#b23a00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40 C25 35, 35 35, 40 30",
    stroke: "#ff9900",
    strokeWidth: 2,
    fill: "none"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 4,
    stroke: "#444",
    strokeWidth: 2,
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 20,
    r: 4,
    stroke: "#444",
    strokeWidth: 2,
    fill: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 22,
    x2: 35,
    y2: 35,
    stroke: "#444",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: 22,
    x2: 18,
    y2: 35,
    stroke: "#444",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.02dac6b9073590050207357cf8622259.svg";
export { ForwardRef as ReactComponent };